import { checkoutDevConfig } from './checkout.config';
import { Environment } from '../app/interfaces/environment';

export const environment: Environment = {
  production: false,
  stage: 'staging',
  apiUrl: 'https://stg.api.inteligenciadevida.com.br/api',
  portalUrl: 'https://stg.portal.inteligenciadevida.com.br',
  storeUrl: 'https://stg.familias.meumundoedu.com.br',
  cypherSecret: '0691a94a00a0ed846e1f7f2bf47c0f03',
  checkout: checkoutDevConfig
};
